<template>
  <div class="payrollImport">
    <v-form v-model="isFormValid" ref="form" class="mt-4" lazy-validation>
      <v-row>
        <v-col cols="4" :style="{ 'max-width': '400px' }">
          <div>
            <v-select
              v-model="investStatus"
              label="Investment status"
              :items="['Provisional', 'Final']"
              :rules="rules"
              outlined
              dense
            ></v-select>
          </div>
          <div>
            <v-select
              v-model="investType"
              label="Investment type"
              :items="investTypeList"
              item-text="Text"
              item-value="Text"
              :rules="rules"
              :loading="isPayrollLoading"
              outlined
              dense
            ></v-select>
          </div>

          <div>
            <DatePicker v-model="investDate" label="Investment date" :rules="rules" />
          </div>

          <div>
            <v-select
              v-if="investType === 'Payroll'"
              v-model="payroll"
              label="Payroll"
              :items="payrollList"
              item-text="Text"
              item-value="Text"
              :rules="rules"
              :loading="isPayrollLoading"
              outlined
              dense
            ></v-select>
          </div>
          <div>
            <v-select
              v-model="payrollToInvest"
              label="Payroll to invest"
              :items="payrollToInvestList"
              item-text="Text"
              item-value="Value"
              :rules="rules"
              :loading="isPayrollToInvestLoading"
              outlined
              dense
            ></v-select>
          </div>
          <div>
            <v-text-field v-model="reference" label="Reference" outlined dense></v-text-field>
          </div>
        </v-col>
      </v-row>
    </v-form>

    <AutomatedTasks processType="Payroll" :counter="counter" />

    <v-footer padless fixed outlined class="pl-5 pr-5 pt-3 pb-3" color="white" elevation="3">
      <v-spacer></v-spacer>

      <v-btn color="primary" :loading="isInvestProcessLoading" depressed @click="processInvestment">
        Process investment
      </v-btn>
    </v-footer>
  </div>
</template>

<script>
import DatePicker from '@/components/formControls/DatePicker.vue';
import AutomatedTasks from './AutomatedTasks.vue';

export default {
  name: 'InvestmentProcess',
  components: { DatePicker, AutomatedTasks },

  data() {
    return {
      isFormValid: false,
      investStatus: null,
      investType: null,
      investTypeList: ['Payroll', 'Lifestyle Switches', 'Leavers', 'Charges'],
      investDate: new Date().toISOString(),
      payroll: null,
      payrollList: [],
      isPayrollLoading: false,
      payrollToInvest: null,
      payrollToInvestList: [],
      isPayrollToInvestLoading: false,
      reference: null,
      isInvestProcessLoading: false,

      rules: [(v) => !!v || 'Required.'],

      counter: 0,
    };
  },

  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
  },

  watch: {
    currentPlanId() {
      if (this.currentPlanId) this.getImportDefifnitionList();
      if (this.currentPlanId && this.payroll && this.investStatus && this.investDate)
        this.getImportedPayriollList();
    },
    payroll() {
      if (this.currentPlanId && this.payroll && this.investStatus && this.investDate)
        this.getImportedPayriollList();
    },
    investStatus() {
      if (this.currentPlanId && this.payroll && this.investStatus && this.investDate)
        this.getImportedPayriollList();
    },
    investDate() {
      if (this.currentPlanId && this.payroll && this.investStatus && this.investDate)
        this.getImportedPayriollList();
    },
  },

  mounted() {
    if (this.currentPlanId) this.getImportDefifnitionList();
  },

  methods: {
    processInvestment() {
      this.isFormValid = this.$refs.form.validate();
      if (!this.isFormValid) return;

      const data = {
        PlanId: this.currentPlanId,
        InvestmentStatus: this.investStatus,
        InvestmentType: this.investType,
        InvestmentPayroll: this.payrollToInvest,
        InvestmentDate: this.investDate,
        PayrollName: this.payroll,
        Reference: this.reference,
      };

      this.startInvestmentProcess(data);
    },

    async getImportDefifnitionList() {
      this.isPayrollLoading = true;

      try {
        const response = await this.$api.get(
          `/Import/GetImportDefinitionList?planId=${this.currentPlanId}&importType=Monthly Payroll`
        );

        this.payrollList = response.data;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.isPayrollLoading = false;
      }
    },

    async getImportedPayriollList() {
      this.isPayrollToInvestLoading = true;

      try {
        const response = await this.$api.get(
          `/Invest/GetImportedPayrollList?planId=${this.currentPlanId}&investStatus=${this.investStatus}&payroll=${this.payroll}&investDate=${this.investDate}`
        );
        this.payrollToInvestList = response.data;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.isPayrollToInvestLoading = false;
      }
    },

    async startInvestmentProcess(data) {
      this.isInvestProcessLoading = true;

      try {
        await this.$api.post('/Automation/StartInvestmentProcess', data);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Investment process started',
        });

        this.investStatus = null;
        this.investType = null;
        this.investDate = new Date().toISOString();
        this.payroll = null;
        this.payrollToInvest = null;
        this.reference = null;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.isInvestProcessLoading = false;
        this.counter += 1;
      }
    },
  },
};
</script>

<style lang="scss">
.payrollImport {
  margin-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;

  .v-data-table tbody tr {
    cursor: default;
  }
}
</style>
